<template>
    <div class="student-avatar" :style="rootStyle">
        <span v-if="!avatar">{{ computedInitials }}</span>
    </div>
</template>

<script>
import { getInitials, getAvatarGradient } from '@/utils/Common'

export default {
    name: "StudentAvatar",
    props: {
        avatar: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: '',
        },
        avatarKey: {
            type: [String, Number],
            default: '',
        },
        size: {
            type: [Number, String],
            default: 34,
        },
        radius: {
            type: [Number, String],
            default: 8,
        },
        fontSize: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        computedInitials(vm = this) {
            return getInitials(vm.name)
        },
        rootStyle(vm = this) {
            const base = {
                width: `${vm.size}px`,
                height: `${vm.size}px`,
                borderRadius: `${vm.radius}px`,
                fontSize: `${vm.fontSize || Math.round(Number(vm.size) * 0.35)}px`,
            }
            if (vm.avatar) {
                return {
                    ...base,
                    backgroundImage: `url(${vm.avatar})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundColor: 'var(--v-surface2-base)',
                }
            }
            return { ...base, ...getAvatarGradient(vm.avatarKey || vm.name) }
        },
    },
}
</script>

<style scoped>
.student-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    letter-spacing: 0.02em;
    flex-shrink: 0;
    overflow: hidden;
}
</style>
